// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0d0324bf","81":"eb6224bb"}[chunkId] + ".chunk.js";
};